import React from "react";
import { Box, Container, Typography } from "@mui/material";

function TermsAndConditions() {
  const textSx = {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#222",
    mb: 1.25,
  };

  const sectionTitleSx = {
    fontSize: "30px",
    fontWeight: 600,
    color: "#111",
    mt: 2.5,
    mb: 1.5,
    lineHeight: 1.2,
  };

  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh", py: 3 }}>
      <Container maxWidth="md" sx={{ px: { xs: 2, md: 3 } }}>
        <Box sx={{ maxWidth: "760px", mx: "auto" }}>
          <Typography sx={{ fontSize: "36px", fontWeight: 700, color: "#111", mb: 1.5 }}>
            Terms and Conditions
          </Typography>

          <Typography sx={textSx}>Welcome to Astegne.com!</Typography>

          <Typography sx={textSx}>
            These terms and conditions outline the rules and regulations for the use of Astegne.com&apos;s Website,
            located at https://www.astegne.com.
          </Typography>

          <Typography sx={textSx}>
            By accessing this website we assume you accept these terms and conditions. Do not continue to use
            Astegne.com if you do not agree to take all of the terms and conditions stated on this page.
          </Typography>

          <Typography sx={textSx}>
            The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice
            and all Agreements: &quot;Client&quot;, &quot;You&quot; and &quot;Your&quot; refers to you, the person log on this website and
            compliant to the Company&apos;s terms and conditions. &quot;The Company&quot;, &quot;Ourselves&quot;, &quot;We&quot;, &quot;Our&quot; and
            &quot;Us&quot;, refers to our Company. &quot;Party&quot;, &quot;Parties&quot;, or &quot;Us&quot;, refers to both the Client and ourselves.
            All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process
            of our assistance to the Client in the most appropriate manner for the express purpose of meeting the
            Client&apos;s needs in respect of provision of the Company&apos;s stated services, in accordance with and subject
            to, prevailing law of Ethiopia.
          </Typography>

          <Typography sx={sectionTitleSx}>Cookies</Typography>
          <Typography sx={textSx}>
            We employ the use of cookies. By accessing Astegne.com, you agreed to use cookies in agreement with the
            Astegne.com&apos;s Privacy Policy.
          </Typography>
          <Typography sx={textSx}>
            Most interactive websites use cookies to let us retrieve the user&apos;s details for each visit. Cookies are
            used by our website to enable the functionality of certain areas to make it easier for people visiting our
            website. Some of our affiliate/advertising partners may also use cookies.
          </Typography>

          <Typography sx={sectionTitleSx}>License</Typography>
          <Typography sx={textSx}>
            Unless otherwise stated, Astegne.com and/or its licensors own the intellectual property rights for all
            material on Astegne.com. All intellectual property rights are reserved. You may access this from
            Astegne.com for your own personal use subjected to restrictions set in these terms and conditions.
          </Typography>
          <Typography sx={textSx}>You must not:</Typography>
          <Box component="ul" sx={{ mt: 0.5, mb: 1.5, pl: 2.8 }}>
            <li>
              <Typography sx={textSx}>Republish material from Astegne.com</Typography>
            </li>
            <li>
              <Typography sx={textSx}>Sell, rent or sub license material from Astegne.com</Typography>
            </li>
            <li>
              <Typography sx={textSx}>Reproduce, duplicate or copy material from Astegne.com</Typography>
            </li>
            <li>
              <Typography sx={textSx}>Redistribute content from Astegne.com</Typography>
            </li>
          </Box>

          <Typography sx={textSx}>
            This Agreement shall begin on the date hereof. Our Terms and Conditions were created with the help of
            free terms and conditions generators.
          </Typography>

          <Typography sx={textSx}>
            Parts of this website offer an opportunity for users to post and exchange opinions and information in
            certain areas of the website. Astegne.com does not filter, edit, publish or review Comments prior to their
            presence on the website. Comments do not reflect the views and opinions of Astegne.com, its agents and/or
            affiliates.
          </Typography>

          <Typography sx={textSx}>
            Astegne.com reserves the right to monitor all Comments and to remove any Comments which can be considered
            inappropriate, offensive or causes breach of these Terms and Conditions.
          </Typography>

          <Typography sx={textSx}>You warrant and represent that:</Typography>
          <Box component="ul" sx={{ mt: 0.5, mb: 1.5, pl: 2.8 }}>
            <li>
              <Typography sx={textSx}>
                You are entitled to post the Comments on our website and have all necessary licenses and consents to
                do so.
              </Typography>
            </li>
            <li>
              <Typography sx={textSx}>
                The Comments do not invade any intellectual property right, including without limitation copyright,
                patent or trademark of any third party.
              </Typography>
            </li>
            <li>
              <Typography sx={textSx}>
                The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful
                material which is an invasion of privacy.
              </Typography>
            </li>
            <li>
              <Typography sx={textSx}>
                The Comments will not be used to solicit or promote business or custom or present commercial
                activities or unlawful activity.
              </Typography>
            </li>
          </Box>

          <Typography sx={sectionTitleSx}>Hyperlinking to our Content</Typography>
          <Typography sx={textSx}>
            The following organizations may link to our website without prior written approval:
          </Typography>
          <Box component="ul" sx={{ mt: 0.5, mb: 1.5, pl: 2.8 }}>
            <li><Typography sx={textSx}>Government agencies;</Typography></li>
            <li><Typography sx={textSx}>Search engines;</Typography></li>
            <li><Typography sx={textSx}>News organizations;</Typography></li>
            <li><Typography sx={textSx}>Online directory distributors;</Typography></li>
            <li><Typography sx={textSx}>System wide accredited businesses.</Typography></li>
          </Box>

          <Typography sx={textSx}>
            We may consider and approve other link requests from commonly-known consumer and/or business information
            sources, dot-com community sites, internet portals, educational institutions and trade associations.
          </Typography>

          <Typography sx={sectionTitleSx}>iFrames</Typography>
          <Typography sx={textSx}>
            Without prior approval and written permission, you may not create frames around our webpages that alter in
            any way the visual presentation or appearance of our website.
          </Typography>

          <Typography sx={sectionTitleSx}>Content Liability</Typography>
          <Typography sx={textSx}>
            We shall not be hold responsible for any content that appears on your website. You agree to protect and
            defend us against all claims that is rising on your website. No link(s) should appear on any website that
            may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates
            the infringement or other violation of, any third party rights.
          </Typography>

          <Typography sx={sectionTitleSx}>Reservation of Rights</Typography>
          <Typography sx={textSx}>
            We reserve the right to request that you remove all links or any particular link to our website. You
            approve to immediately remove all links to our website upon request. We also reserve the right to amend
            these terms and conditions and it&apos;s linking policy at any time.
          </Typography>

          <Typography sx={sectionTitleSx}>Removal of links from our website</Typography>
          <Typography sx={textSx}>
            If you find any link on our website that is offensive for any reason, you are free to contact and inform
            us any moment. We will consider requests to remove links but we are not obligated to or so or to respond
            to you directly.
          </Typography>
          <Typography sx={textSx}>
            We do not ensure that the information on this website is correct, we do not warrant its completeness or
            accuracy; nor do we promise to ensure that the website remains available or that the material on the
            website is kept up to date.
          </Typography>

          <Typography sx={sectionTitleSx}>Disclaimer</Typography>
          <Typography sx={textSx}>
            To the maximum extent permitted by applicable law, we exclude all representations, warranties and
            conditions relating to our website and the use of this website. Nothing in this disclaimer will:
          </Typography>
          <Box component="ul" sx={{ mt: 0.5, mb: 1.5, pl: 2.8 }}>
            <li><Typography sx={textSx}>limit or exclude our or your liability for death or personal injury;</Typography></li>
            <li><Typography sx={textSx}>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</Typography></li>
            <li><Typography sx={textSx}>limit any of our or your liabilities in any way that is not permitted under applicable law;</Typography></li>
            <li><Typography sx={textSx}>exclude any of our or your liabilities that may not be excluded under applicable law.</Typography></li>
          </Box>
          <Typography sx={textSx}>
            As long as the website and the information and services on the website are provided free of charge, we
            will not be liable for any loss or damage of any nature.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default TermsAndConditions;
